import React from 'react'
import PDFCollectionPupils from './PDFCollectionPupils'
import PDFCollectionTeacher from './PDFCollectionTeacher'
import route from '../stores/fetchconfig.json'


class PDFCollectionPupilsAndTeacher extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
     teacherComponentReady:false,
     pupilsComponentReady:false
    }
  }

  printIt () {
   setTimeout(window.print,80)
  }

  addPrintEventsToWindow () {
    window.onafterprint = () => {
     this.props.history.replace(route.endpoint + '/')
    }
  }

  componentWillMount () {
   this.addPrintEventsToWindow()
  }

  teacherComponentReady = () => {
    this.setState({teacherComponentReady:true},this.checkIfReadyForPrint)
  }

  pupilsComponentReady = () => {
    this.setState({pupilsComponentReady:true},this.checkIfReadyForPrint)
  }

  checkIfReadyForPrint () {
    if (this.state.teacherComponentReady && this.state.pupilsComponentReady) {
      this.printIt()
    }
  }

  render () {
    return (
      <div>
       <PDFCollectionTeacher isReady={this.teacherComponentReady} />
       <PDFCollectionPupils isReady={this.pupilsComponentReady} />
      </div>
    )
  }
}

export default PDFCollectionPupilsAndTeacher



// WEBPACK FOOTER //
// ./src/components/PDFCollectionPupilsAndTeacher.js